import { createContext } from 'react'
import type { NavCollapseState } from './use-nav-collapse'

/**
 * Provided by AppShell so BottomNav and the content padding share one
 * collapse state. BottomNav falls back to its own state when rendered
 * outside an AppShell.
 */
export const NavCollapseContext = createContext<NavCollapseState | null>(null)
